<template>
  <md-tab id="tab-industry" md-label="Industry" md-icon="business">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 order-2">
        <div id="divIndustries" v-if="this.dataAccess">
          <div
            v-for="index in this.industriesArray"
            :key="index"
            :id="index"
            :ref="index"
            :class="`len2-${getIndustryName(index)} available unclicked count-industry`"
            @click="selectIndustry($event)"
          >[{{ index }}] {{ getIndustryName(index) }}</div>
        </div>
      </div>
    </div>
  </md-tab>
</template>

<script>
import axios from 'axios';

export default {
  name: 'industry-tab',
  props: ['dataAccess'],
  data() {
    return {
      apiIndustries: undefined,
      industriesLen2: [],
      loaded: false,
      paddingMultiplier: 0,
      previousBznaics: '',
      parentBznaics: '',
      searchPaddingMultiplier: 0,
      searchParentBznaics: '',
      searchPreviousBznaics: '',
      countIndustry: 0,
      industriesArray: [],
    };
  },
  mounted() {
    if (this.dataAccess)
      this.industriesArray = this.dataAccess.sectors;
  },
  methods: {
    getIndustryName: function (index) {
      return this.dataAccess.nameList[index];
    },
    selectIndustry: function (event) {
      if (event.target.id.length == 2) {
        let divIndustries = document.getElementById('divIndustries')
        let divIndustriesChildren = [...[].slice.call(document.getElementById('divIndustries').getElementsByTagName('*'), 0)];

        divIndustriesChildren.forEach(element => {
          if (element.id != event.target.id)
            divIndustries.removeChild(element);
        })

        let arrayElementsToAppend = this.dataAccess.naics3list[event.target.id];

        arrayElementsToAppend.forEach(item => {
          let elementToAppend = document.createElement('div');
          elementToAppend.setAttribute(
            'style',
            `margin-left: 30px`
          );
          elementToAppend.textContent = `[${item}] ${this.getIndustryName(item)}`;

          elementToAppend.setAttribute(
            'class',
            `len2-${this.getIndustryName(item)} available unclicked count-industry`
          );
          elementToAppend.setAttribute(
            'id',
            `${item}`
          );
          elementToAppend.addEventListener("click", this.selectIndustry);
          divIndustries.appendChild(elementToAppend)
        })
      }
      else {
        let divIndustries = document.getElementById('divIndustries')
        let divIndustriesChildren = [...[].slice.call(document.getElementById('divIndustries').getElementsByTagName('*'), 0)];

        divIndustriesChildren.forEach(element => {
          if (element.id != event.target.id && element.id.length != 2)
            divIndustries.removeChild(element);
        })

        let arrayElementsToAppend = this.dataAccess.industries[event.target.id];
        if (arrayElementsToAppend) {
          arrayElementsToAppend.forEach(item => {
            let elementToAppend = document.createElement('div');
            elementToAppend.setAttribute(
              'style',
              `margin-left: 45px`
            );
            elementToAppend.textContent = `[${item}] ${this.getIndustryName(item)}`;

            elementToAppend.setAttribute(
              'class',
              `len2-${this.getIndustryName(item)} available unclicked count-industry`
            );
            elementToAppend.setAttribute(
              'id',
              `${item}`
            );
            elementToAppend.addEventListener("click", this.selectIndustry);
            divIndustries.appendChild(elementToAppend)
          })
        }
      }
      this.countIndustry++;
      this.$store.commit('MULT_SET_COUNT', this.countIndustry);
      this.$store.commit('MULT_SET_CURRENT_INDUSTRY', event.target.innerText);

      if (this.currentIndustry && this.currentSalesClass && this.multCount > 2)
        this.searchResults();
    },
    searchResults: async function () {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search/multiples',
          {},
          {
            params: {
              /**
               * Required parameters:
               */
              session_id: currentSession,
              bznaics: this.getData(this.currentIndustry),
              sales_class: this.getData(this.currentSalesClass)
            },
          }
        )
        .then((res) => {
          this.$store.commit('MULT_SET_SEARCHES_RESULT', res.data.search_results);
        });
    },
    getData: function (name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    getName: function (name) {
      return name.split('[')[0];
    },
  },
  computed: {
    multCount() {
      return this.$store.getters.multCount;
    },
    currentIndustry() {
      return this.$store.getters.multCurrentIndustry;
    },
    currentSalesClass() {
      return this.$store.getters.multCurrentSalesClass;
    }
  },

  watch: {
    dataAccess(newValue, oldValue) {
      if (newValue)
        this.industriesArray = this.dataAccess.sectors;
    },
    industriesArray(newValue, oldValue) {
      let elements = [...document.getElementsByClassName('count-industry')];
      if (elements) {
        newValue.forEach(id => {
          let element = document.getElementById(`industry-11`);

        });
      }
    },
   
  },
};
</script>
<style lang="scss">
.unavailable {
  pointer-events: none;
  opacity: 0.5;
  color: #3c4858;
  font-size: 0.9375rem;
  margin: 16px;
}
.available {
  color: #3c4858;
  font-size: 0.9375rem;
  cursor: pointer;
  margin: 16px;
  transition: 0.5s;
}
.search-indent {
  padding-left: 32px;
}
.available:hover {
  color: #1a7bfa;
  transition: 0.5s;
}

</style>
